import React from "react";
import { Check } from "@phosphor-icons/react";

/** CHOOSE -> CUSTOMIZE -> ACTIVATE progress header. */
export function StepFlow({ steps, current }) {
  return (
    <div data-testid="step-flow" className="mb-8 flex items-center gap-2 overflow-hidden">
      {steps.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <React.Fragment key={label}>
            <div className="flex items-center gap-2">
              <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition-colors ${
                done ? "bg-primary text-primary-foreground" : active ? "bg-primary text-primary-foreground ring-4 ring-accent" : "bg-secondary text-muted-foreground"
              }`}>
                {done ? <Check size={16} weight="bold" /> : i + 1}
              </div>
              <span className={`text-xs font-semibold uppercase tracking-[0.14em] ${active ? "inline" : "hidden sm:inline"} ${active || done ? "text-foreground" : "text-muted-foreground"}`}>{label}</span>
            </div>
            {i < steps.length - 1 && <div className={`h-px flex-1 ${done ? "bg-primary" : "bg-border"}`} />}
          </React.Fragment>
        );
      })}
    </div>
  );
}
